/**
 * TCS-8180: helpers for the cookie-consent wire format (LGPD/ANPD).
 */

/**
 * Format a date as ISO 8601 with the local UTC offset and second precision,
 * e.g. '2026-10-28T16:10:00-03:00' — the format expected by the consent API
 * (Date.toISOString() would emit UTC with millis and a 'Z' suffix instead).
 */
export function formatIsoWithOffset(date: Date = new Date()): string {
  const pad = (value: number) => String(value).padStart(2, '0')

  /** Offset in minutes: positive west of UTC (getTimezoneOffset convention) */
  const offsetMinutes = date.getTimezoneOffset()
  const offsetSign = offsetMinutes <= 0 ? '+' : '-'
  const absOffset = Math.abs(offsetMinutes)
  const offsetHours = pad(Math.floor(absOffset / 60))
  const offsetMins = pad(absOffset % 60)

  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`
}
